"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var voyageBackground_hyper_sidecar_1 = require("@voyage/background/voyageBackground_hyper-sidecar");
var voyageBackground_starfield_sidecar_1 = require("@voyage/background/voyageBackground_starfield-sidecar");
function create() {
    voyageBackground_starfield_sidecar_1.voyageBackground_starfield.reset();
    voyageBackground_hyper_sidecar_1.voyageBackground_hyper.reset();
}
exports.create = create;
function update() {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    voyageBackground_starfield_sidecar_1.voyageBackground_starfield.updateAll();
    voyageBackground_hyper_sidecar_1.voyageBackground_hyper.updateAll();
}
exports.update = update;
